// extracted by mini-css-extract-plugin
export var outerContainer = "layout-module--outer-container--ElKbw";
export var innerContainer = "layout-module--inner-container--D5KrP";